// src/context/AppContext.js
import React, { createContext, useContext } from 'react';
import useNavigation from '../hooks/useNavigation';

// Create context
const AppContext = createContext();

/**
 * App context provider component
 */
export const AppProvider = ({ children }) => {
  // Navigation state and handlers
  const navigation = useNavigation();
  
  // Values to be provided to the context
  const contextValue = {
    ...navigation,
  };
  
  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
};

/**
 * Custom hook to use the app context
 */
export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};